

export default function Footer() {
    return (
        <div className="w-full mt-auto pt-4 text-center text-[11px] text-gray-500 border-t border-gray-100 bg-gray-50/50 rounded-b-lg">
            <p className="mb-1 leading-relaxed">Developed by <span className='text-[#74B0FA] font-semibold'>SQUBIX DIGITAL</span></p>
            <p className="leading-relaxed mb-0">Last Updated : Feb 27, 2026</p>
        </div>
    );
}